import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Button, Card, Icon, Img, Text } from '../../Atoms';
import { Input, Upload } from '../../Molecules';
import { DescriptionSendDocument, OrganismFormDocument } from '../../Organisms';
import success from '../../assets/img/doc-success.png';
import DocumentData from '../../Json/Document.json';
function TemplateSendDocument(props) {
  console.log(
    'STEPPP',
    props.state.step,
    props.state.category,
    props.state.type
  );
  return (
    <div
      className="template-container template-send-document template-scroll"
      style={{
        paddingBottom: 70,
        ...(props.state.step === 4 ? { overflow: 'hidden' } : {})
      }}
    >
      <div className="container-title-send-doc">
        <Icon
          icon="SortTop"
          size="20px"
          className="icon-return"
          onClick={() => props.onReturn()}
        />
        <Text text="Mes documents" className="title-send-document" />
      </div>
      {props.state.step === 2 || props.state.step === 1 ? (
        <div className="content-template-document">
          <div className="container-text-type-doc">
            <Text
              text={
                props.state.step === 1
                  ? 'Quel type de document souhaitez-vous nous envoyer ?'
                  : 'Merci de bien vouloir préciser votre type de document'
              }
              className="text-type-doc"
              type="h8"
              style={{ textAlign: 'center' }}
            />
          </div>
          <Row>
            {props.state.step === 1 &&
              props.categories
                .filter((el) => el.parentId == null)
                .map((el, index) => (
                  <Col
                    key={String(index)}
                    md={6}
                    xs={12}
                    className={
                      index % 2 === 0
                        ? 'container-left-card-doc'
                        : 'container-right-card-doc'
                    }
                  >
                    <Card
                      size="small"
                      text={el.name}
                      className="card-type-doc"
                      onClick={() => props.selectElement(el)}
                    />
                  </Col>
                ))}
            {props.state.step === 2 &&
              props.state.categoryList.map((el, index) => (
                <Col
                  key={String(index)}
                  md={
                    props.state.categoryList.length % 2 === 1
                      ? index + 1 === props.state.categoryList.length
                        ? 12
                        : 6
                      : 6
                  }
                  xs={12}
                  className={
                    props.state.categoryList.length % 2 === 1 &&
                    index + 1 === props.state.categoryList.length
                      ? 'container-center'
                      : index % 2 === 0
                      ? 'container-left-card-doc'
                      : 'container-right-card-doc'
                  }
                >
                  <Card
                    size="small"
                    text={el.name}
                    className="card-type-doc"
                    onClick={() => props.selectCategory(el)}
                  />
                </Col>
              ))}
          </Row>
        </div>
      ) : props.state.step === 3 ? (
        <div>
          <Row>
            <Col xs={12} md={7}>
              <div className="container-description-condition-send-document">
                <DescriptionSendDocument
                  type={props.state.type}
                  category={props.state.category}
                />
              </div>
            </Col>
            <Col xs={12} md={5} className="container-col-send-doc">
              <OrganismFormDocument
                selectFile={props.selectFile}
                files={props.state.files}
                description={props.state.description}
                onSubmit={props.onSubmit}
                onChange={props.onChange}
                type={props.state.type}
                category={props.state.category}
                onChangeMedicine={props.onChangeMedicine}
                medicine={props.state.medicine}
                errorsMedecine={props.state.errorsMedecine}
                medicineStep={props.medicineStep}
                openNewMutual={props.openNewMutual}
                closeNewMutual={props.closeNewMutual}
                stepMedicine={props.state.stepMedicine}
                showNewMutual={props.state.showNewMutual}
                mutual={props.state.mutual}
                onChangeMutual={props.onChangeMutual}
                remboursement={props.state.remboursement}
                isUploadValid={props.state.isUploadValid}
                isDescriptionValid={props.state.isDescriptionValid}
                errorsUpload={props.errorsUpload}
                beneficiaries={props.beneficiaries}
                sendDocumentIsLoading={props.state.sendDocumentIsLoading}
              />
            </Col>
          </Row>
        </div>
      ) : (
        <div className="container-success">
          <Text
            text="Votre document a bien été envoyé."
            type="h4"
            className="doc-success-msg"
          />
          <div className="img-success-document" />
        </div>
      )}
    </div>
  );
}
export default TemplateSendDocument;
